import { Controller } from "@hotwired/stimulus"
import Rails from "@rails/ujs"

export default class extends Controller {
  static targets = ['modal', 'fileName', 'fileCsv']
  static values = { validateCsvUrl: String }

  onChangeFileUserCsv(event) {
    this.fileNameTarget.innerText = event.target.files[0].name
  }

  onClickFileUserCsv(event) {
    event.stopPropagation()

    this.fileCsvTarget.value = null
  }

  openModal() {
    this.modalTarget.setAttribute("style", "display: block;")
  }

  closeModal() {
    this.modalTarget.setAttribute("style", "display: none;")
  }

  clearData(event) {
    const id = event.target.dataset.doctor_id
    const date = event.target.dataset.date

    Rails.ajax({
      url: `/admin/doctor_schedules/clear_data_table?id=${id}&date=${date}`,
      type: "GET",
      dataType: 'json',
      success: (response)=> {
      }
    });
  }

  changeData(event) {
    const valTd = event.target.dataset.value
    const scheduleId = event.target.dataset.id
    const elementsTd = document.querySelectorAll(`.td-${scheduleId}`)
    const elementData = document.querySelector(`.data-${scheduleId}`)
    let string = ''

    event.target.classList.add("bg-yellow");

    if(valTd == "1") {
      event.target.dataset.value = "0"
      event.target.classList.remove("bg-normal");
      event.target.innerHTML = "◎"
    } else {
      event.target.dataset.value = "1"
      event.target.classList.remove("bg-gray");
      event.target.innerHTML = "✕"
    }

    Array.from(elementsTd).forEach((element) => {
      string += element.dataset.value
    });
    elementData.dataset.change = string

    if(elementData.dataset.change != elementData.dataset.original) {
      elementData.classList.add("is-changed")
    } else {
      elementData.classList.remove("is-changed")
    }
  }

  updateData(event){
    const id = event.target.dataset.doctor_id
    const date = event.target.dataset.date
    let data = []
    const elements = document.querySelectorAll('.is-changed');

    Array.from(elements).forEach((element) => {
      data.push(
        {
          id: element.dataset.id,
          available_time: element.dataset.change
        }
      )
    });
    
    Rails.ajax({
      url: '/admin/doctor_schedules/update_multi_data',
      type: 'PATCH',
      beforeSend(xhr, options) {
        xhr.setRequestHeader('Content-Type', 'application/json; charset=UTF-8')
        options.data = JSON.stringify({update_multi_data: data, id: id, date: date})
        return true
      },
      success: (response)=> {
      }
    });
  }
}
